var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { value: _vm.show, persistent: "", "max-width": "424" },
      on: { "update:returnValue": _vm.handleClose }
    },
    [
      _c("v-card", { staticClass: "confirm-dialog-container" }, [
        _c("div", { staticClass: "cofirm-dialog-img-wrapper" }, [
          _c("img", {
            attrs: { src: require("@/assets/images/mobile_notification.svg") }
          })
        ]),
        _vm._v(" "),
        _c(
          "h2",
          {
            staticClass:
              "text-xs-center headline font-weight--medium czn-black--text text--black-87"
          },
          [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("dialog.mobileNotification.title")) +
                "\n    "
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "p",
          {
            staticClass:
              "mobile-notification-dialog__description subheading czn-black--text text--black-54 text-xs-center"
          },
          [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("dialog.mobileNotification.content")) +
                "\n      "
            ),
            _c("br"),
            _vm._v(" "),
            _c("br"),
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("dialog.mobileNotification.remark")) +
                "\n      "
            ),
            _c("br"),
            _vm._v("service@conzian.com\n    ")
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "confirm-dialog-footer" },
          [
            _c(
              "v-btn",
              {
                staticClass: "confirm-dialog-footer__btn ma-0",
                attrs: { depressed: "", color: "primary", block: "" },
                on: { click: _vm.handleClose }
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("dialog.mobileSimpleNotification.action")) +
                    "\n      "
                )
              ]
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-061d2346", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-061d2346","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MobileNotification.vue
// module id = null
// module chunks = 